import React from "react"
import Button from "storybookComponents/Button"
import IconComponent from "components/IconComponent"
import "./index.css"
import { SmallPreviewUrl } from "icons"
import { getUpdatedValue } from "../utils"
import Switch from 'components/Switch/simpleSwitch'
import Tooltip from "storybookComponents/Tooltip2";

const TooltipText = ({ classes, tooltip }) => {
  const { sentTo, when, sentBy } = tooltip;
  return (
    <div>
      <div>
        <span className={classes.tooltipKeyStyle}>Sent To: </span>
        {sentTo}
      </div>
      <div>
        <span className={classes.tooltipKeyStyle}>When: </span> {when}
      </div>
      <div>
        <span className={classes.tooltipKeyStyle}>Sent By: </span> {sentBy}
      </div>
    </div>
  );
}

const EmailCard = ({ classes, item, timezoneString, handleToggleEmails, toggleModal, onEditClickCallback }) => {
  const updated = getUpdatedValue(item.updated_at, timezoneString)

  const handlePreviewClick = () => {
    window.open(item.preview_url)
  }

  const handleEditClick = () => {
    onEditClickCallback(item)
  }

  const onToggleEmails = (toggle, prev) => {
    return handleToggleEmails(toggle, prev, item.emailName, item.graphqlKey)
  }

  return (
    <Tooltip text={<TooltipText classes={classes} tooltip={item.tooltip} />} position="bottom">
      <div className="email-container">
        <div className="emails-banner">
          <div>
            <Button className={classes.bannerBtnStyle} onClick={handleEditClick} variant="secondary">Edit Email</Button>
            <Button className={classes.bannerBtnStyle} onClick={() => toggleModal(item)} variant="tertiary">Send Test
            </Button>
            <Button className={classes.bannerBtnStyle} onClick={handlePreviewClick} variant="tertiary">Preview <IconComponent className={classes.iconStyle} Component={SmallPreviewUrl} />
            </Button>
          </div>
        </div>
        <div className={classes.imgFrameClass}>
          <iframe id="Iframe" scrolling="no" className={classes.iFrameClass} srcDoc={item.prevHtml} />
        </div>
        <div className={classes.bottomContainer}>
          <div>
            <div className={classes.eventTitle}>{item.emailName}</div>
            <div className={classes.updatedText}>Edited: {updated > 1 ? `${updated} days` : `${updated} day`} ago</div>
          </div>
          <div className={classes.switchContainer}>
            <Switch
              toggled={item.active}
              onToggle={onToggleEmails}
            />
          </div>
        </div>
      </div>
    </Tooltip>
  )
}

export default EmailCard